<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <div class="row col-12">
          <div class="col-12">
            <button @click="certificarCargos()" class="btn btn-md btn-outline-primary" style="float: right">
              <i class="fas fa-file-export fa-lg"></i>
              <i class="fas fa-file-alt fa-lg"></i> &nbsp;&nbsp;Certificarlas
              Todas
            </button>
            <div style="text-align: left;">
              <h5 class="form-header">Cargos pendientes de subir a Fel</h5>
            </div>
          </div>
        </div>
        <br>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div>
              <div class="form-inline justify-content-sm-end">
                <input class="form-control form-control-sm rounded bright" placeholder="Serie cargo"
                  v-model="search.cargo_serie" type="text" style="width: 100px; text-transform: uppercase"
                  v-on:keyup.enter="filterData" />
                &nbsp;&nbsp;
                <input class="form-control form-control-sm rounded bright" placeholder="Nit cliente"
                  v-model="search.cliente" type="text" v-on:keyup.enter="filterData"
                  style="width: 115px; text-transform: uppercase" />
                &nbsp;&nbsp;
                <input class="form-control form-control-sm rounded bright" placeholder="# Cargo" v-model="search.numero"
                  type="text" style="width: 115px; text-transform: uppercase" v-on:keyup.enter="filterData" />
                &nbsp;&nbsp;
                <input type="date" v-model="search.fecha" class="form-control form-control-sm rounded bright" />
                &nbsp;&nbsp;
                <select class="form-control form-control-sm rounded bright" v-model="filtro_estado" @change="filterData">
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                  <option value="E">IMPRESA</option>
                </select>
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" v-on:click="filterData">
                    <i class="fa fa-search"></i>
                    Buscar
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData">
                    <i class="fa fa-times"></i>
                    Limpiar Datos
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CargoTableComponent :data="data" />
        <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
      </div>
    </div>
  </div>
</template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CargoTableComponent from "@/components/cxc/cargos/CargoTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    CargoTableComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
  },
  data() {
    return {
      data: {},
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      search: {},
    };
  },
  mounted() {
    let self = this;
    self.refreshData();
  },
  methods: {
    certificarCargos() {
      let self = this;
      Notifications.alert.confirm(
        "¿Seguro?",
        "Este procedimiento intentara certificar 10 facturas de las pendientes",
        "Si Abrir",
        function () {
          DynamicService.postActionList("cxc", "cargos", "enviar_fel_todos")
            .then((response) => {
              Notifications.alert.success(
                "Certificación de facturas",
                "realizado exitosamente"
              );
              self.refreshData();
            })
            .catch((error) => {
              console.log(error.response.data);
              Notifications.alert.error(
                "Certificación de facturas",
                error.response.data.detail
              );
            });
        }
      );
    },
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    onPageChange(page) {
      let self = this;
      this.currentPage = page;
      DynamicService.fetch("cxc", "cargos", {
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
        pendiente_enviar_fel: true,
      }).then((response) => {
        self.data = response.data;
      });
    },
    refreshData() {
      let self = this;
      DynamicService.fetch("cxc", "cargos", {
        pendiente_enviar_fel: true,
      }).then((response) => {
        self.data = response.data;
      });
    },
    filterData() {
      this.$data.currentPage = 1;
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      DynamicService.fetch("cxc", "cargos", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
        pendiente_enviar_fel: true,
      })
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          this.data = "";
        });
    },
    clearFilterData() {
      this.search = {
        cargo_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      };
      this.$data.currentPage = 1;
      this.filterData();
    },
  },
};
</script>
